<div id="container-load" fxFlex="100" fxLayoutAlign="center center">
    <!-- <img fxFlex="10" fxFlex.xs="50" src="/assets/icons/spinner.gif" alt="Cargando..."> -->
    <img fxFlex="10" src="../../../assets/gift/loading polimentes.gif">
</div>
